import React from 'react';
import {ObjectPropertyDetails} from "../../../types/Object";
import {ExternalLink} from "../../../common/ExternalLink";
import {ShowMore} from "../../../common/show-more/ShowMore";

type ResourcePropertyViewProps = {
  property: ObjectPropertyDetails
}

export default class ResourcePropertyView extends React.Component<ResourcePropertyViewProps> {

  static canHandle(property: ObjectPropertyDetails): boolean {
    return property.type === "ID";
  }

  render() {
    const property = this.props.property;
    if (property.multi) {
      if (property.value.length < 2) {
        return <ExternalLink href={property.value[0]}/>;
      }
      return renderMultiResource(property.value);
    }
    return <ExternalLink href={property.value}/>;
  }
}

function renderMultiResource(values: any) {
  const resources = values.map((values: any, index: number) => {
    return <li key={index}><ExternalLink href={values}/></li>;
  });
  return <ul><ShowMore elements={resources}/></ul>;
}
